module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.cbb54037.png";